import { useCallback } from 'react';
import { useIntl } from 'react-intl';

import { PilotId } from '~/types/PilotId';
import { User } from '~/types/User';
import { getUserName } from '~/utils/user';

import { ESignatureIntegrationUser } from '../../types';

export const useMapResolvedUsers = () => {
  const intl = useIntl();
  return useCallback(
    (
      currentUser: User | undefined,
      data: ESignatureIntegrationUser[],
      resolvedUsers: Record<PilotId, User> | undefined,
      searchKeyword?: string,
    ) => {
      if (!resolvedUsers) return [];

      const keyword = searchKeyword?.toLowerCase() ?? '';
      return data
        .map((integrationUser) => {
          const user =
            resolvedUsers[
              integrationUser.attributes.internal_user_id as PilotId
            ];
          if (!user) return { ...integrationUser, resolvedUserName: '' };

          const name = getUserName(user, intl);
          const resolvedUserName =
            currentUser?.id === user.id
              ? intl?.formatMessage(
                  {
                    id: 'UserName.currentUser',
                    defaultMessage: '{userName} (You)',
                    description:
                      'Label for the current user in user name display. Example: userName = "John Smith"',
                  },
                  { userName: name },
                )
              : name;

          return { ...integrationUser, resolvedUserName };
        })
        .filter(
          ({ resolvedUserName, attributes }) =>
            resolvedUserName?.toLowerCase().includes(keyword) ||
            attributes.external_user_email?.toLowerCase().includes(keyword),
        );
    },
    [],
  );
};
